module.exports = __webpack_public_path__ + "static/media/Somi-icon-01-01-sm.30fa6309.png";